import React from 'react';

const DEFAULT_INIT: RequestInit = {
  method: 'GET',
  cache: 'no-cache',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
  },
};

export function useVariousFetch<T>(): {
  loading: boolean;
  data: T | null;
  fetcher: (input: RequestInfo, init?: RequestInit) => Promise<T>;
} {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [data, setData] = React.useState<T | null>(null);

  const fetcher = React.useCallback(
    (input: RequestInfo, init?: RequestInit): Promise<T> => {
      setLoading(true);

      const option = {
        ...DEFAULT_INIT,
        ...init,
      };

      return fetch(input, option)
        .then(
          (response: Response): Promise<T> =>
            response.json().then((json): T => {
              setData(json);
              return json;
            })
        )
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log((error as Error).message);
          return Promise.reject({} as T);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    []
  );

  return {
    loading,
    data,
    fetcher,
  };
}
